"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _constants = require("./constants");
var _types = require("./types");
var _types2 = require("../websocket/types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  isInternetReachable: true,
  // when we can ping google for exemple
  isBackendReachable: false,
  // when ws is not reachable
  isBackendTerminated: false,
  // when ws is not needed anymore (end room for example)
  isConnected: true,
  // device browser detection, could be with non detectable connection cut
  backendConnectivityStatus: _constants.READY_STATE.CLOSED,
  backendConnectivityError: null,
  quality: _constants.QUALITY.OFFLINE,
  wsSocketId: null,
  // ws spark id
  wsReconnectIn: null,
  wsReconnectAttempt: 0,
  bandwidth: {
    down: 0,
    // in KB/s
    up: 0,
    // in KB/s
    estimatedAt: 0,
    processing: false
  }
};
var networkReducer = function networkReducer() {
  var _action$payload, _action$payload2, _action$payload3, _action$payload4, _action$payload5;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.UPDATE_NETWORK_CONNECTED:
      if (action.isConnected) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isConnected: true,
          wsReconnectIn: null,
          wsReconnectAttempt: 0
        });
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        isConnected: false
      });
    case _types2.WS_CONNECTING:
      return _objectSpread(_objectSpread({}, state), {}, {
        backendConnectivityStatus: _constants.READY_STATE.OPENING,
        wsReconnectIn: (action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.scheduled) || 1,
        wsReconnectAttempt: (action === null || action === void 0 || (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.attempt) || null
      });
    case _types2.WS_RECONNECT_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        backendConnectivityStatus: _constants.READY_STATE.CLOSED,
        isBackendReachable: false,
        backendConnectivityError: (_action$payload3 = action.payload) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.message
      });
    case _types2.WS_CONNECT:
      return _objectSpread(_objectSpread({}, state), {}, {
        isBackendReachable: true,
        backendConnectivityStatus: _constants.READY_STATE.OPEN,
        backendConnectivityError: null,
        wsReconnectIn: null,
        wsReconnectAttempt: 0
      });
    case _types2.WS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        backendConnectivityError: (_action$payload4 = action.payload) === null || _action$payload4 === void 0 ? void 0 : _action$payload4.reason
      });
    case _types2.WS_CLOSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isBackendReachable: false,
        backendConnectivityStatus: _constants.READY_STATE.CLOSED,
        quality: _constants.QUALITY.OFFLINE,
        wsSocketId: null
      });
    case _types.UPDATE_NETWORK:
      return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
        bandwidth: _objectSpread(_objectSpread({}, state.bandwidth || {}), ((_action$payload5 = action.payload) === null || _action$payload5 === void 0 ? void 0 : _action$payload5.bandwidth) || {})
      });
    case _types.SET_BACKEND_TERMINATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isBackendTerminated: true
      });
    default:
      return state;
  }
};
var _default = exports.default = networkReducer;
module.exports = exports.default;